














































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as shareApi from '../api/shareApi'

@Component({
  components: {},
})
export default class Index extends Vue {
  message: any = {}
  goTest: boolean = true
  ios10Shadow: boolean = false
  babyName: string = ''
  dateVal: any = null
  birth_date: any = ''
  class_level: any = ''
  english_level: any = ''
  popupVisible: boolean = false
  editType: number = 1
  dataList: any = []
  grades: any[] = [
    {
      values: [
        '学龄前',
        '一年级',
        '二年级',
        '三年级',
        '四年级',
        '五年级',
        '初一',
        '初二',
        '初三',
        '高一',
        '高二',
        '高三及以上',
      ],
      defaultIndex: 3,
      value: '三年级',
    },
  ]
  years: any[] = [
    {
      values: [
        '少于1年',
        '1年',
        '2年',
        '3年',
        '4年',
        '5年',
        '6年',
        '7年',
        '8年',
        '9年',
        '10年',
        '11年',
        '12年及以上',
      ],
      defaultIndex: 3,
      value: '2年',
    },
  ]
  temp_value: any = ''
  gradeIndex: number
  englishIndex: number
  // 声明宝贝信息对象
  get testValue() {
    let value = {
      babyName: this.babyName,
      birth_date: this.birth_date,
      class_level: this.class_level,
      english_level: this.english_level,
    }
    return value
  }
  // 监听宝贝信息对象
  @Watch('testValue')
  getValue(val) {
    if (
      val.babyName &&
      val.birth_date &&
      val.class_level &&
      val.english_level
    ) {
      this.goTest = false
    } else {
      this.goTest = true
    }
  }
  async mounted() {
    window.onbeforeunload = null
    await env.init()
    env.type === 'wx' && (await shareApi.share())
    await this.userData()
  }
  // 获取用户数据
  async userData() {
    let { data } = await shareApi.requireGet(
      '/api/m-course/lexile/getStudentInfo'
    )
    this.message = data
    if (data.birthdate) {
      this.dateVal = data.birthdate
    }
    this.dateConfirm()
    if (data.nickname) {
      this.babyName = data.nickname
    }
    if (data.grade !== -1) {
      this.class_level = this.grades[0].values[data.grade]
      this.gradeIndex = data.grade
    }
    if (data.years_english !== -1) {
      this.english_level = this.years[0].values[data.years_english]
      this.englishIndex = data.years_english
    }
  }
  // ios10 env.login()页面不刷新问题
  async ios10ShadowClick() {
    window.location.reload()
  }
  // 更新提交用户信息,跳转测评页面
  async goToTest() {
    if (!this.goTest) {
      await shareApi.requirePost('/api/m-course/lexile/updateStudentInfo', {
        nickname: this.babyName,
        birthdate: this.birth_date,
        grade: this.gradeIndex,
        years_english: this.englishIndex,
      })
      window.location.href = `${
        window.location.origin
      }/act2/reimsAssess/needKnow?_hideShareButton=1`
    } else {
      return
    }
  }
  // 编辑生日
  editBirth() {
    ;(this.$refs.datePicker as any).open()
  }
  // 编辑年级和学龄
  async editAttr(type) {
    this.editType = type
    this.dataList = type === 1 ? this.grades : this.years
    if (this.editType === 1) {
      if (this.class_level) {
        this.grades[0].defaultIndex =
          this.grades[0].values.findIndex(item => item === this.english_level) +
          1
        this.grades[0].value = this.class_level
      }
    } else {
      if (this.english_level) {
        this.years[0].defaultIndex =
          this.years[0].values.findIndex(item => item === this.english_level) +
          1
        this.years[0].value = this.english_level
      }
    }
    await this.$nextTick()
    this.popupVisible = true
  }
  // 监听picker选择器数据
  async onValuesChange(picker, values) {
    this.temp_value = values[0]
    picker.setSlotValue(1, values[0])
  }
  // 更新picker数据
  async handleConfirm() {
    if (this.editType === 1) {
      this.class_level = this.temp_value
      this.gradeIndex = this.grades[0].values.indexOf(this.temp_value)
    } else {
      this.english_level = this.temp_value
      this.englishIndex = this.years[0].values.indexOf(this.temp_value)
    }
    this.temp_value = ''
    this.popupVisible = false
  }
  // 取消picker数据
  async handleCancel() {
    this.temp_value = ''
    this.popupVisible = false
  }
  // 设置生日时间确定
  async dateConfirm() {
    let date = new Date(this.dateVal)
    this.birth_date =
      date.getFullYear() +
      '-' +
      this.addZero(date.getMonth() + 1) +
      '-' +
      this.addZero(date.getDate())
  }
  // 转换数字格式
  addZero(i) {
    return i < 10 ? '0' + i : i + ''
  }
}
